import { netsuiteAccioneRoles } from '../../acciones-roles/reportes/netsuite-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const NetsuiteGeneralRoutes: SideBarButton = {
  data: {
    name: 'Netsuite',
    appendUrl: './reportsPBI/netsuite',
    roles: netsuiteAccioneRoles.sideNavActions.netsuitePbi,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Pallets',
        url: '/pallets',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'DayStar',
        overWriteUrl: './reportsPBI/daystar/invoices',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Delivery',
        url: '/delivery',
      },
      options: PreConfigButton3,
    },
  ],
};

export const NetsuiteSalesOrderRoutes: SideBarButton = {
  data: {
    name: 'Netsuite - SO',
    appendUrl: './reportsPBI/netsuite',
    roles: netsuiteAccioneRoles.sideNavActions.netsuitePbi,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Private Labels',
        url: '/departments',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'General data',
        url: '/sales-orders',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Finished good',
        url: '/calculator',
      },
      options: PreConfigButton3,
    },
  ],
};
export const NetsuiteWorkOrderRoutes: SideBarButton = {
  data: {
    name: 'Netsuite - WO',
    appendUrl: './reportsPBI/netsuite/work-orders',
    roles: netsuiteAccioneRoles.sideNavActions.netsuitePbi,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Private Labels',
        url: '/private-label',
      },
      options: PreConfigButton3,
    },
  ],
};
